package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets8 {
  internal val _27_tehilim_066_txt: AssetResource by lazy { init__27_tehilim_066_txt() }

  internal val _27_tehilim_067_txt: AssetResource by lazy { init__27_tehilim_067_txt() }

  internal val _27_tehilim_068_txt: AssetResource by lazy { init__27_tehilim_068_txt() }

  internal val _27_tehilim_069_txt: AssetResource by lazy { init__27_tehilim_069_txt() }

  internal val _27_tehilim_070_txt: AssetResource by lazy { init__27_tehilim_070_txt() }

  internal val _27_tehilim_071_txt: AssetResource by lazy { init__27_tehilim_071_txt() }

  internal val _27_tehilim_072_txt: AssetResource by lazy { init__27_tehilim_072_txt() }

  internal val _27_tehilim_073_txt: AssetResource by lazy { init__27_tehilim_073_txt() }

  internal val _27_tehilim_074_txt: AssetResource by lazy { init__27_tehilim_074_txt() }

  internal val _27_tehilim_075_txt: AssetResource by lazy { init__27_tehilim_075_txt() }

  internal val _27_tehilim_076_txt: AssetResource by lazy { init__27_tehilim_076_txt() }

  internal val _27_tehilim_077_txt: AssetResource by lazy { init__27_tehilim_077_txt() }

  internal val _27_tehilim_078_txt: AssetResource by lazy { init__27_tehilim_078_txt() }

  internal val _27_tehilim_079_txt: AssetResource by lazy { init__27_tehilim_079_txt() }

  internal val _27_tehilim_080_txt: AssetResource by lazy { init__27_tehilim_080_txt() }

  internal val _27_tehilim_081_txt: AssetResource by lazy { init__27_tehilim_081_txt() }

  internal val _27_tehilim_082_txt: AssetResource by lazy { init__27_tehilim_082_txt() }

  internal val _27_tehilim_083_txt: AssetResource by lazy { init__27_tehilim_083_txt() }

  internal val _27_tehilim_084_txt: AssetResource by lazy { init__27_tehilim_084_txt() }

  internal val _27_tehilim_085_txt: AssetResource by lazy { init__27_tehilim_085_txt() }

  internal val _27_tehilim_086_txt: AssetResource by lazy { init__27_tehilim_086_txt() }

  internal val _27_tehilim_087_txt: AssetResource by lazy { init__27_tehilim_087_txt() }

  internal val _27_tehilim_088_txt: AssetResource by lazy { init__27_tehilim_088_txt() }

  internal val _27_tehilim_089_txt: AssetResource by lazy { init__27_tehilim_089_txt() }

  internal val _27_tehilim_090_txt: AssetResource by lazy { init__27_tehilim_090_txt() }

  internal val _27_tehilim_091_txt: AssetResource by lazy { init__27_tehilim_091_txt() }

  internal val _27_tehilim_092_txt: AssetResource by lazy { init__27_tehilim_092_txt() }

  internal val _27_tehilim_093_txt: AssetResource by lazy { init__27_tehilim_093_txt() }

  internal val _27_tehilim_094_txt: AssetResource by lazy { init__27_tehilim_094_txt() }

  internal val _27_tehilim_095_txt: AssetResource by lazy { init__27_tehilim_095_txt() }

  internal val _27_tehilim_096_txt: AssetResource by lazy { init__27_tehilim_096_txt() }

  internal val _27_tehilim_097_txt: AssetResource by lazy { init__27_tehilim_097_txt() }

  internal val _27_tehilim_098_txt: AssetResource by lazy { init__27_tehilim_098_txt() }

  internal val _27_tehilim_099_txt: AssetResource by lazy { init__27_tehilim_099_txt() }

  internal val _27_tehilim_100_txt: AssetResource by lazy { init__27_tehilim_100_txt() }

  internal val _27_tehilim_101_txt: AssetResource by lazy { init__27_tehilim_101_txt() }

  internal val _27_tehilim_102_txt: AssetResource by lazy { init__27_tehilim_102_txt() }

  internal val _27_tehilim_103_txt: AssetResource by lazy { init__27_tehilim_103_txt() }

  internal val _27_tehilim_104_txt: AssetResource by lazy { init__27_tehilim_104_txt() }

  internal val _27_tehilim_105_txt: AssetResource by lazy { init__27_tehilim_105_txt() }

  internal val _27_tehilim_106_txt: AssetResource by lazy { init__27_tehilim_106_txt() }

  internal val _27_tehilim_107_txt: AssetResource by lazy { init__27_tehilim_107_txt() }

  internal val _27_tehilim_108_txt: AssetResource by lazy { init__27_tehilim_108_txt() }

  internal val _27_tehilim_109_txt: AssetResource by lazy { init__27_tehilim_109_txt() }

  internal val _27_tehilim_110_txt: AssetResource by lazy { init__27_tehilim_110_txt() }

  internal val _27_tehilim_111_txt: AssetResource by lazy { init__27_tehilim_111_txt() }

  internal val _27_tehilim_112_txt: AssetResource by lazy { init__27_tehilim_112_txt() }

  internal val _27_tehilim_113_txt: AssetResource by lazy { init__27_tehilim_113_txt() }

  internal val _27_tehilim_114_txt: AssetResource by lazy { init__27_tehilim_114_txt() }

  internal val _27_tehilim_115_txt: AssetResource by lazy { init__27_tehilim_115_txt() }

  internal fun values(): List<AssetResource> = listOf(_27_tehilim_066_txt, _27_tehilim_067_txt,
      _27_tehilim_068_txt, _27_tehilim_069_txt, _27_tehilim_070_txt, _27_tehilim_071_txt,
      _27_tehilim_072_txt, _27_tehilim_073_txt, _27_tehilim_074_txt, _27_tehilim_075_txt,
      _27_tehilim_076_txt, _27_tehilim_077_txt, _27_tehilim_078_txt, _27_tehilim_079_txt,
      _27_tehilim_080_txt, _27_tehilim_081_txt, _27_tehilim_082_txt, _27_tehilim_083_txt,
      _27_tehilim_084_txt, _27_tehilim_085_txt, _27_tehilim_086_txt, _27_tehilim_087_txt,
      _27_tehilim_088_txt, _27_tehilim_089_txt, _27_tehilim_090_txt, _27_tehilim_091_txt,
      _27_tehilim_092_txt, _27_tehilim_093_txt, _27_tehilim_094_txt, _27_tehilim_095_txt,
      _27_tehilim_096_txt, _27_tehilim_097_txt, _27_tehilim_098_txt, _27_tehilim_099_txt,
      _27_tehilim_100_txt, _27_tehilim_101_txt, _27_tehilim_102_txt, _27_tehilim_103_txt,
      _27_tehilim_104_txt, _27_tehilim_105_txt, _27_tehilim_106_txt, _27_tehilim_107_txt,
      _27_tehilim_108_txt, _27_tehilim_109_txt, _27_tehilim_110_txt, _27_tehilim_111_txt,
      _27_tehilim_112_txt, _27_tehilim_113_txt, _27_tehilim_114_txt, _27_tehilim_115_txt)
}

private fun init__27_tehilim_066_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-066.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-066.txt")

private fun init__27_tehilim_067_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-067.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-067.txt")

private fun init__27_tehilim_068_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-068.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-068.txt")

private fun init__27_tehilim_069_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-069.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-069.txt")

private fun init__27_tehilim_070_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-070.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-070.txt")

private fun init__27_tehilim_071_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-071.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-071.txt")

private fun init__27_tehilim_072_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-072.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-072.txt")

private fun init__27_tehilim_073_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-073.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-073.txt")

private fun init__27_tehilim_074_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-074.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-074.txt")

private fun init__27_tehilim_075_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-075.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-075.txt")

private fun init__27_tehilim_076_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-076.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-076.txt")

private fun init__27_tehilim_077_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-077.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-077.txt")

private fun init__27_tehilim_078_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-078.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-078.txt")

private fun init__27_tehilim_079_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-079.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-079.txt")

private fun init__27_tehilim_080_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-080.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-080.txt")

private fun init__27_tehilim_081_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-081.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-081.txt")

private fun init__27_tehilim_082_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-082.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-082.txt")

private fun init__27_tehilim_083_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-083.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-083.txt")

private fun init__27_tehilim_084_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-084.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-084.txt")

private fun init__27_tehilim_085_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-085.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-085.txt")

private fun init__27_tehilim_086_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-086.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-086.txt")

private fun init__27_tehilim_087_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-087.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-087.txt")

private fun init__27_tehilim_088_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-088.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-088.txt")

private fun init__27_tehilim_089_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-089.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-089.txt")

private fun init__27_tehilim_090_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-090.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-090.txt")

private fun init__27_tehilim_091_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-091.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-091.txt")

private fun init__27_tehilim_092_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-092.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-092.txt")

private fun init__27_tehilim_093_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-093.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-093.txt")

private fun init__27_tehilim_094_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-094.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-094.txt")

private fun init__27_tehilim_095_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-095.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-095.txt")

private fun init__27_tehilim_096_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-096.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-096.txt")

private fun init__27_tehilim_097_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-097.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-097.txt")

private fun init__27_tehilim_098_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-098.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-098.txt")

private fun init__27_tehilim_099_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-099.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-099.txt")

private fun init__27_tehilim_100_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-100.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-100.txt")

private fun init__27_tehilim_101_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-101.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-101.txt")

private fun init__27_tehilim_102_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-102.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-102.txt")

private fun init__27_tehilim_103_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-103.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-103.txt")

private fun init__27_tehilim_104_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-104.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-104.txt")

private fun init__27_tehilim_105_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-105.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-105.txt")

private fun init__27_tehilim_106_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-106.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-106.txt")

private fun init__27_tehilim_107_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-107.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-107.txt")

private fun init__27_tehilim_108_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-108.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-108.txt")

private fun init__27_tehilim_109_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-109.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-109.txt")

private fun init__27_tehilim_110_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-110.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-110.txt")

private fun init__27_tehilim_111_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-111.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-111.txt")

private fun init__27_tehilim_112_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-112.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-112.txt")

private fun init__27_tehilim_113_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-113.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-113.txt")

private fun init__27_tehilim_114_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-114.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-114.txt")

private fun init__27_tehilim_115_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-115.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-115.txt")

public actual val SharedRes.assets.allChapters._27_tehilim_066_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_066_txt

public actual val SharedRes.assets.allChapters._27_tehilim_067_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_067_txt

public actual val SharedRes.assets.allChapters._27_tehilim_068_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_068_txt

public actual val SharedRes.assets.allChapters._27_tehilim_069_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_069_txt

public actual val SharedRes.assets.allChapters._27_tehilim_070_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_070_txt

public actual val SharedRes.assets.allChapters._27_tehilim_071_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_071_txt

public actual val SharedRes.assets.allChapters._27_tehilim_072_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_072_txt

public actual val SharedRes.assets.allChapters._27_tehilim_073_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_073_txt

public actual val SharedRes.assets.allChapters._27_tehilim_074_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_074_txt

public actual val SharedRes.assets.allChapters._27_tehilim_075_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_075_txt

public actual val SharedRes.assets.allChapters._27_tehilim_076_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_076_txt

public actual val SharedRes.assets.allChapters._27_tehilim_077_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_077_txt

public actual val SharedRes.assets.allChapters._27_tehilim_078_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_078_txt

public actual val SharedRes.assets.allChapters._27_tehilim_079_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_079_txt

public actual val SharedRes.assets.allChapters._27_tehilim_080_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_080_txt

public actual val SharedRes.assets.allChapters._27_tehilim_081_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_081_txt

public actual val SharedRes.assets.allChapters._27_tehilim_082_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_082_txt

public actual val SharedRes.assets.allChapters._27_tehilim_083_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_083_txt

public actual val SharedRes.assets.allChapters._27_tehilim_084_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_084_txt

public actual val SharedRes.assets.allChapters._27_tehilim_085_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_085_txt

public actual val SharedRes.assets.allChapters._27_tehilim_086_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_086_txt

public actual val SharedRes.assets.allChapters._27_tehilim_087_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_087_txt

public actual val SharedRes.assets.allChapters._27_tehilim_088_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_088_txt

public actual val SharedRes.assets.allChapters._27_tehilim_089_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_089_txt

public actual val SharedRes.assets.allChapters._27_tehilim_090_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_090_txt

public actual val SharedRes.assets.allChapters._27_tehilim_091_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_091_txt

public actual val SharedRes.assets.allChapters._27_tehilim_092_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_092_txt

public actual val SharedRes.assets.allChapters._27_tehilim_093_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_093_txt

public actual val SharedRes.assets.allChapters._27_tehilim_094_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_094_txt

public actual val SharedRes.assets.allChapters._27_tehilim_095_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_095_txt

public actual val SharedRes.assets.allChapters._27_tehilim_096_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_096_txt

public actual val SharedRes.assets.allChapters._27_tehilim_097_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_097_txt

public actual val SharedRes.assets.allChapters._27_tehilim_098_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_098_txt

public actual val SharedRes.assets.allChapters._27_tehilim_099_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_099_txt

public actual val SharedRes.assets.allChapters._27_tehilim_100_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_100_txt

public actual val SharedRes.assets.allChapters._27_tehilim_101_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_101_txt

public actual val SharedRes.assets.allChapters._27_tehilim_102_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_102_txt

public actual val SharedRes.assets.allChapters._27_tehilim_103_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_103_txt

public actual val SharedRes.assets.allChapters._27_tehilim_104_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_104_txt

public actual val SharedRes.assets.allChapters._27_tehilim_105_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_105_txt

public actual val SharedRes.assets.allChapters._27_tehilim_106_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_106_txt

public actual val SharedRes.assets.allChapters._27_tehilim_107_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_107_txt

public actual val SharedRes.assets.allChapters._27_tehilim_108_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_108_txt

public actual val SharedRes.assets.allChapters._27_tehilim_109_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_109_txt

public actual val SharedRes.assets.allChapters._27_tehilim_110_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_110_txt

public actual val SharedRes.assets.allChapters._27_tehilim_111_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_111_txt

public actual val SharedRes.assets.allChapters._27_tehilim_112_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_112_txt

public actual val SharedRes.assets.allChapters._27_tehilim_113_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_113_txt

public actual val SharedRes.assets.allChapters._27_tehilim_114_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_114_txt

public actual val SharedRes.assets.allChapters._27_tehilim_115_txt: AssetResource
  get() = CommonMainAssets8._27_tehilim_115_txt
